import React from 'react';

/*
  App-level error boundary. React render errors (e.g. an [object Promise] reaching JSX as a
  child under a newer Chromium/Edge engine) otherwise unmount the whole tree and leave a blank
  page. This catches them so we:
    1. log the component stack - available even in a minified production build via
       errorInfo.componentStack - so the offending component can be pinpointed, and
    2. show a fallback instead of a white screen.
  Kept dependency-light (plain elements) so the boundary itself can't fail to render.
*/
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ESS] Render error:', error, '\n[ESS] Component stack:', errorInfo && errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{ margin: '5rem auto', maxWidth: 520, textAlign: 'center', fontFamily: 'Roboto, sans-serif', color: '#3e6b7b' }}>
          <h3>Something went wrong.</h3>
          <p>Please refresh the page. If the problem continues, please contact support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
